import { faUser } from "@fortawesome/free-solid-svg-icons";
import { SECRET_INPUT_TYPE, VALIDATION_ERROR_MESSAGE, Yup } from "@mavichpe/dynamic-forms";

const LoginFormConfig = {
    submit: {
        label: "Ingresar"
    },
    sections: [{
        hideBorderBottom: true,
        fields: [
            [
                {
                    "type": "email",
                    "name": "username",
                    "label": "Email",
                    "isHorizontal": true,
                    "labelSizing": {
                        "sm": 5,
                        "md": 4
                    },
                    "prefix": faUser,
                    "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                }
            ],
            [
                {
                    "type": SECRET_INPUT_TYPE,
                    "name": "password",
                    "label": "Contraseña",
                    "isHorizontal": true,
                    "labelSizing": {
                        "sm": 5,
                        "md": 4
                    },
                    "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                }
            ],
        ]
    }]
};


export default LoginFormConfig;